import React from 'react'
import HeroCollage from './HeroCollage'

interface HeroProps {
  qrCodeSrc: string
  getAppHref: string
}

const Hero: React.FC<HeroProps> = ({ qrCodeSrc, getAppHref }) => {
  return (
    <div id="top">
      <header className="v2-hero">
        <HeroCollage />

        <div className="v2-hero__card">
          <h1 className="v2-hero__title">
            The dating app that
            <br />
            only works <em>IRL</em>
          </h1>
          <p className="v2-hero__subtitle">Find a spot. See who’s there. Meet someone you’d have walked right past.</p>

          <div className="v2-hero__cta-row">
            <a data-mobile-only="true" href={getAppHref} className="v2-btn v2-btn--primary v2-btn--lg">
              Get the app
            </a>
            <div data-desktop-only="true" className="v2-hero__qr">
              <a aria-label="Download Ivy" className="v2-qr-link" href={getAppHref}>
                <img alt="QR code to download Ivy" height={140} width={140} src={qrCodeSrc} />
              </a>
              <span>Scan to download the app</span>
            </div>
          </div>
        </div>
      </header>
    </div>
  )
}

export default Hero
